import React, { useState } from "react"
import { Container, Row, Col, Modal, ModalHeader, ModalBody, Button } from "reactstrap"
import * as s from "./style.module.css"
import Dots from "../Dots/index"
import useLabels from "../../utils/useLabels"

import labels from "../Summary2026/const"
import Numbers from "../Numbers"
import Text from "../Text"
import Workshops, { Workshop } from "../Workshops"
import Mentors from "../Mentors"
import Partners, { PartnersCard } from "../Partners"
import WorkshopsFull from "../WorkshopsFullDesc"
import MentorsFull from "../MentorsWithDesc"
import Gadget from "../Gadget"
import Localization from "../Localization"
import Idea from "../Idea"

export default function Summary2026({ lang }) {
  const t = useLabels(labels, lang)

  // Stan dla nowego modala projektów
  const [selectedProject, setSelectedProject] = useState(null)
  const [isProjectModalOpen, setIsProjectModalOpen] = useState(false)

  const openProjectModal = (project) => {
    setSelectedProject(project)
    setIsProjectModalOpen(true)
  }

  const closeProjectModal = () => {
    setIsProjectModalOpen(false)
    setSelectedProject(null)
  }

  return (
    <div className={s.root}>

      <Idea type="ecoFuture" isReverse />

      <Container className="mb-5">

        {/* Projects section */}
        <div className="mt-5">
          <div className={s.header}>
            <h2>{t.projects2024.projectsTitle}</h2>
            <div className={s.divider} />
          </div>

          <p
            className={s.summaryText}
            dangerouslySetInnerHTML={{ __html: t.projects2024.summary }}
          />
        </div>

      </Container>

      <div className={[s.bgWrapper, "px-5"].join(" ")}>

        <h2 className="text-primary mb-3">Projekt zaczęty podczas hackathonu</h2>

        <div className="position-relative">

          <Col>
            <div className={[s.project, s.winners, s.highlight].join(" ")}>
              <div className="d-flex flex-column">

                <div className="w-100">
                  <h1 className={s.winnersTitle}>{t.projects2024.category1.winners.name}</h1>
                  <img alt="" className={[s.winnersImg].join(" ")} src={t.projects2024.category1.winners.image} />
                  <h5 className={[s.place, "text-center"].join(" ")}>
                    {t.projects2024.category1.winners.place}
                  </h5>

                  <div
                    className={s.text}
                    dangerouslySetInnerHTML={{ __html: t.projects2024.category1.winners.text }}
                  />
                </div>
              </div>
            </div>
            <div className={[s.project, s.winners, s.highlight].join(" ")}>
              <div className="d-flex flex-column">

                <div className="w-100">
                  <h1 className={s.winnersTitle}>{t.projects2024.category1.winners2.name}</h1>
                  <img alt="" className={[s.winnersImg].join(" ")} src={t.projects2024.category1.winners2.image} />
                  <h5 className={[s.place, "text-center"].join(" ")}>
                    {t.projects2024.category1.winners2.place}
                  </h5>

                  <div
                    className={s.text}
                    dangerouslySetInnerHTML={{ __html: t.projects2024.category1.winners2.text }}
                  />
                </div>
              </div>
            </div>

            <div className={[s.project, s.winners, s.highlight].join(" ")}>
              <div className="d-flex flex-column">

                <div className="w-100">
                  <h1 className={s.winnersTitle}>{t.projects2024.category1.winners3.name}</h1>
                  <img alt="" className={[s.winnersImg].join(" ")} src={t.projects2024.category1.winners3.image} />
                  <h5 className={[s.place, "text-center"].join(" ")}>
                    {t.projects2024.category1.winners3.place}
                  </h5>

                  <div
                    className={s.text}
                    dangerouslySetInnerHTML={{ __html: t.projects2024.category1.winners3.text }}
                  />
                </div>
              </div>
            </div>
          </Col>

          <Col>
            <h2 className="text-primary mb-3">Projekt rozwijany podczas hackathonu</h2>

            <div className={[s.project, s.winners, s.highlight].join(" ")}>
              <div className="d-flex flex-column">

                <div className="w-100">
                  <h1 className={s.winnersTitle}>{t.projects2024.category2.winners.name}</h1>
                  <img alt="" className={[s.winnersImg].join(" ")} src={t.projects2024.category2.winners.image} />
                  <h5 className={[s.place, "text-center"].join(" ")}>
                    {t.projects2024.category2.winners.place}
                  </h5>

                  <div
                    className={s.text}
                    dangerouslySetInnerHTML={{ __html: t.projects2024.category2.winners.text }}
                  />
                </div>
              </div>
            </div>

          </Col>

          <Col>
            <h2 className="text-primary mb-3">Wyróżnienia</h2>

            <div className={[s.project, s.winners, s.highlight].join(" ")}>
              <div className="d-flex flex-column">

                <div className="w-100">
                  <h1 className={s.winnersTitle}>{t.projects2024.category3.winners.name}</h1>
                  <img alt="" className={[s.winnersImg].join(" ")} src={t.projects2024.category3.winners.image} />
                  <h5 className={[s.place, "text-center"].join(" ")}>
                    {t.projects2024.category3.winners.place}
                  </h5>

                  <div
                    className={s.text}
                    dangerouslySetInnerHTML={{ __html: t.projects2024.category3.winners.text }}
                  />
                </div>
              </div>
            </div>

            <div className={[s.project, s.winners, s.highlight].join(" ")}>
              <div className="d-flex flex-column">

                <div className="w-100">
                  <h1 className={s.winnersTitle}>{t.projects2024.category3.winners2.name}</h1>
                  <img alt="" className={[s.winnersImg].join(" ")} src={t.projects2024.category3.winners2.image} />
                  <h5 className={[s.place, "text-center"].join(" ")}>
                    {t.projects2024.category3.winners2.place}
                  </h5>

                  <div
                    className={s.text}
                    dangerouslySetInnerHTML={{ __html: t.projects2024.category3.winners2.text }}
                  />
                </div>
              </div>
            </div>

          </Col>

          {/* Sekcja "Pozostałe projekty" - 3 kolumny, tylko nazwa na kafelku */}
          <h2 className="text-primary mb-4">Pozostałe projekty</h2>

          <Row xs={1} sm={2} md={3} className="g-4">
            {t.projects2024.projects.map((project, idx) => (
              <Col key={idx} className="mb-4 px-3">
                <ProjectTile
                  name={project.name}
                  onClick={() => openProjectModal(project)}
                />
              </Col>
            ))}
          </Row>

        </div>
      </div>

      {/* Nowy modal dedykowany dla projektów */}
      <ProjectModal
        isOpen={isProjectModalOpen}
        toggle={closeProjectModal}
        project={selectedProject}
      />

      <section id="workshop-2026">
        <WorkshopsFull workshops={t.workshops2026} />
      </section>

      <section id="mentors-2026">
        <MentorsFull mentors={t.mentors2026} />
      </section>

      <section id="partners-2026">
        <div className={s.root}>
          <Container className={s.container}>

            <div className={s.header}>
              <h2 className={s.partnersTitle}>{t.partners2026.organizers.title}</h2>
              <img
                className={s.line}
                src={require("../Text/icons/line.svg").default}
              />

              {t.partners2026.organizers.logos.map(({ title, elements }) => (
                <PartnersCard key={title} title={title} elements={elements} />
              ))}
            </div>

            <div className={s.header}>
              <h2 className={s.partnersTitle}>{t.partners2026.title}</h2>
              <img
                className={s.line}
                src={require("../Text/icons/line.svg").default}
              />

              {t.partners2026.partners.logos.map(({ title, elements }) => (
                <PartnersCard key={title} title={title} elements={elements} />
              ))}
            </div>
          </Container>
        </div>
      </section>

    </div >
  )
}

// Komponent kafelka wyświetlający wyłącznie Nazwę Projektu
function ProjectTile({ name, onClick }) {
  return (
    <div
      className={[s.project, s.highlight, "d-flex align-items-center justify-content-center p-4 text-center h-100"].join(" ")}
      onClick={onClick}
      style={{ cursor: "pointer", minHeight: "120px" }}
    >
      <h4 className={[s.projectTitle, "m-0"].join(" ")}>{name}</h4>
    </div>
  )
}

// Nowy dedykowany modal projektów
function ProjectModal({ isOpen, toggle, project }) {
  if (!project) return null

  const teamName = project.teamName || project.place

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="lg">
      {/* Własny nagłówek z pewnym i czytelnym przyciskiem 'X' */}
      <div className="d-flex justify-content-between align-items-center p-3 border-bottom position-relative">
        <h3 className="text-primary mb-0 pe-4">{project.name}</h3>
        <button
          type="button"
          className="btn-close-custom"
          onClick={toggle}
          aria-label="Zamknij"
          style={{
            background: "none",
            border: "none",
            fontSize: "1.8rem",
            lineHeight: "1",
            cursor: "pointer",
            padding: "0 8px",
            color: "#6c757d",
            fontWeight: "bold"
          }}
        >
          &times;
        </button>
      </div>

      <ModalBody className="p-4">
        {teamName && (
          <h5 className="text-muted mb-4 fs-6">
            <strong>Zespół:</strong> {teamName}
          </h5>
        )}

        {project.image && (
          <div className="text-center mb-4">
            <img
              src={project.image}
              alt={project.name}
              className="img-fluid rounded"
              style={{ maxHeight: "300px", objectFit: "cover" }}
            />
          </div>
        )}

        {project.text && (
          <div>
            <h6 className="fw-bold mb-2">Opis projektu:</h6>
            <div
              className={s.text}
              dangerouslySetInnerHTML={{ __html: project.text }}
            />
          </div>
        )}
      </ModalBody>
    </Modal>
  )
}